export const RefreshCircle = (props: any) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z"
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00635 9.06799C5.11885 9.25549 5.25634 9.4305 5.41259 9.58675C6.56259 10.7367 8.43134 10.7367 9.58759 9.58675C10.0563 9.118 10.3251 8.52422 10.4126 7.91797"
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5874 7.08011C4.6749 6.46761 4.94366 5.88008 5.41241 5.41133C6.56241 4.26133 8.43115 4.26133 9.5874 5.41133C9.7499 5.57383 9.88115 5.74884 9.99365 5.93009"
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.88721 10.7371V9.06836H6.55595"
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1126 4.26172V5.93046H8.44385"
      stroke={
        props.strokeColor ? props.strokeColor : "var(--color-icon-obscure)"
      }
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
